import { logError } from 'utils';

const googleAnalytics4Id = process.env.GOOGLE_ANALYTICS_4_ID;

export const gtag4Init = ({ user } = {}) => {
  if (user?.id && window.dataLayer && googleAnalytics4Id) {
    const newUser =
      user?.status === 'ACTIVE' &&
      user?.numbers?.completedOperations >= 1 &&
      user?.numbers?.completedOperations <= 3
        ? 'true'
        : 'false';
    window.gtag('config', googleAnalytics4Id, {
      user_id: user.id,
    });
    window.gtag('set', 'user_properties', {
      new_user: newUser,
    });
  }
};

export const trackCustomEvent = (event, params = {}) => {
  try {
    if (globalThis.dataLayer) {
      const payload = {
        event,
        ...params,
      };
      globalThis.dataLayer.push(payload);
    }
  } catch (error) {
    logError('something went wrong when trying to track a custom event', error);
  }
};

export const trackPageView = (screenName, params = {}) => {
  try {
    if (globalThis.dataLayer) {
      globalThis.dataLayer.push({
        event: 'page_view',
        screen_name: screenName,
        ...params,
      });
    }
  } catch (error) {
    logError('something went wrong when trying to track a pageView event', error);
  }
};

export const TRACKING_EVENTS = {
  POPUP: 'pop_up',
  ADD_FUNDS: 'agregar_fondos',
  WITHDRAW_FUNDS: 'retirar_fondos',
  REQUEST_FUNDS: 'solicitar_fondos',
};
